import { render, staticRenderFns } from "./BarLoader.vue?vue&type=template&id=1cdb25ce&"
import script from "./BarLoader.vue?vue&type=script&lang=js&"
export * from "./BarLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports